<button
  type="button"
  class="__toggle-button"
  [class.is-active]="isActive()"
  [class.is-disabled]="disabled()"
  mat-button>
  <ng-content />
</button>
